"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const Panel_1 = require("@ntet/fos-ui/dist/Components/Panel");
const Loader_1 = require("@ntet/fos-ui/dist/Animations/Loader");
const fos_auth_1 = require("@ntet/fos-auth");
const core_1 = require("@material-ui/core");
const NotificationsList_1 = tslib_1.__importDefault(require("../NotificationsList"));
const utils_1 = require("./utils");
// eslint-disable-next-line max-lines-per-function
const NotificationsPanel = ({ isPanelOpen, setIsPanelOpen, staticNotifications, }) => {
    const isFirstLoad = (0, react_1.useRef)(true);
    const [virtualizedListUpdateBit, setVirtualizedListUpdateBit] = (0, react_1.useState)(false);
    const [notifications, setNotifications] = (0, react_1.useState)(null);
    const [showAlerts, setShowAlerts] = (0, react_1.useState)(false);
    const [showTasks, setShowTasks] = (0, react_1.useState)(false);
    const [isLoadingData, setIsLoadingData] = (0, react_1.useState)(false);
    const triggerVirtualizedListUpdate = (0, react_1.useCallback)(() => {
        setVirtualizedListUpdateBit(val => !val);
    }, [setVirtualizedListUpdateBit]);
    const { request } = (0, fos_auth_1.useAPI)('SentinelApi', {
        'x-ntfos-authorization': 'Authorization',
    });
    const onPanelClose = () => {
        setIsPanelOpen(false);
    };
    const getNotificationData = (0, react_1.useCallback)(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        // TODO: combine filters here
        const params = {};
        params.statusIDs = '2,3,4,6';
        params.showActionableOnly = true;
        setIsLoadingData(true);
        const { data } = yield request({
            url: 'notifications',
            method: 'GET',
            params,
        });
        setIsLoadingData(false);
        const notificationData = (0, utils_1.transformData)(data);
        setNotifications(notificationData);
    }), [setNotifications, request]);
    (0, react_1.useEffect)(() => {
        if (staticNotifications && !notifications) {
            setNotifications(staticNotifications);
            return;
        }
        if (isPanelOpen) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            getNotificationData(); // TODO: convert to hook
            return;
        }
        if (isFirstLoad.current) {
            isFirstLoad.current = false;
        }
    }, [staticNotifications, isPanelOpen]); // TODO: add filters here
    const onOperation = (0, react_1.useCallback)((operation, notificationID, completedCallback) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            console.log('starting request');
            const { data } = yield request({
                url: `notifications/status/batch`,
                method: 'POST',
                data: {
                    actionIDs: `${notificationID}`,
                    operation,
                    notes: '',
                },
            });
            console.log(data);
            setNotifications((notifs) => notifs.filter(notification => notification.notificationID !== notificationID));
        }
        catch (err) {
            console.log('ERROR!', err);
        }
        completedCallback(true); // TODO: pass back success/failure data
    }), [
        request
    ]);
    const sortedNotifications = (0, react_1.useMemo)(() => {
        if (!notifications) {
            return null;
        }
        const currentDate = new Date();
        const pastDue = [];
        const dueInFuture = [];
        const remaining = [];
        for (let i = 0; i < notifications.length; i++) {
            const notification = notifications[i];
            if (notification.dueDate) {
                if (notification.dueDate <= currentDate) {
                    pastDue.push(notification);
                }
                else {
                    dueInFuture.push(notification);
                }
            }
            else {
                remaining.push(notification);
            }
        }
        pastDue.sort((a, b) => a.dueDate.getTime() - b.dueDate.getTime());
        dueInFuture.sort((a, b) => (a.dueDate.getTime() - b.dueDate.getTime()));
        remaining.sort((a, b) => a.triggerTimestamp.getTime() - b.triggerTimestamp.getTime());
        return [...pastDue, ...dueInFuture, ...remaining];
    }, [notifications]);
    const filteredAndSortedNotifications = (0, react_1.useMemo)(() => {
        if ((!showAlerts && !showTasks) ||
            (showAlerts && showTasks)) {
            return sortedNotifications;
        }
        const targetActionTypeName = showAlerts ? 'Alert' : 'Task';
        const filteredNotifications = sortedNotifications && sortedNotifications.filter(notification => notification.actionTypeName === targetActionTypeName);
        return filteredNotifications;
    }, [sortedNotifications, showAlerts, showTasks]);
    (0, react_1.useEffect)(() => {
        triggerVirtualizedListUpdate();
    }, [showAlerts, showTasks, filteredAndSortedNotifications, triggerVirtualizedListUpdate]);
    return ((0, jsx_runtime_1.jsxs)(StyledPanel, Object.assign({ open: isPanelOpen, onClose: onPanelClose, anchor: 'right', size: 'small', "data-testid": 'notifications-view-panel', zIndex: 1250 }, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(TitleContainer, { children: (0, jsx_runtime_1.jsx)(StyledTitle, { children: "Notifications" }) }) }), (0, jsx_runtime_1.jsxs)(FilterContainer, { children: [(0, jsx_runtime_1.jsx)(ToggleButton, Object.assign({ active: showAlerts, onClick: () => { setShowAlerts((value) => !value); } }, { children: "Alerts" })), (0, jsx_runtime_1.jsx)(ToggleButton, Object.assign({ active: showTasks, onClick: () => { setShowTasks((value) => !value); } }, { children: "Tasks" }))] }), (0, jsx_runtime_1.jsx)(ControlsContainer, {}), (0, jsx_runtime_1.jsx)(PanelContent, { children: isLoadingData
                    ? (0, jsx_runtime_1.jsx)(LoadingContainer, { children: (0, jsx_runtime_1.jsx)(Loader_1.Loader, {}) })
                    : (filteredAndSortedNotifications &&
                        (0, jsx_runtime_1.jsx)(NotificationsList_1.default, { notifications: filteredAndSortedNotifications, onOperation: onOperation, virtualizedListUpdateBit: virtualizedListUpdateBit })) })] })));
};
exports.default = NotificationsPanel;
const StyledPanel = (0, styled_components_1.default)(Panel_1.Panel) `
  && .panelPaper {
    width: 58.9rem;
  }
`;
const StyledTitle = styled_components_1.default.span `
  color: ${({ theme }) => theme.colors.NTDarkGrey[900]};
  font-family: ${({ theme }) => theme.fonts.robotoMedium};
  font-size: 1.8rem;
  align-self: center;
  font-size: 15px;
  font-weight: bold;
`;
const TitleContainer = styled_components_1.default.div `
  padding-left: 24px; 
  padding-right: 24px;
  display: flex;
  align-items: center;
  height: 64px;
  background: ${({ theme }) => theme.colors.NTDarkGrey[50]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.NTDarkGrey[200]};
`;
const FilterContainer = styled_components_1.default.div `
  min-height: 62px;
  box-sizing: border-box;
  padding: 16px;
  background: white;
  && > *:not(:first-child) {
    margin-left: 4px;
  }
`;
const ToggleButton = (0, styled_components_1.default)(core_1.ButtonBase) `
  && {
    border-radius: 15px;
    background-color: ${({ active, theme }) => active ? theme.colors.NTDarkGrey[900] : theme.colors.NTDarkGrey[50]};
    padding: 6px 10px;

    color: ${({ active, theme }) => active ? 'white' : theme.colors.NTDarkGrey[900]};
    font-weight: bold;
    font-size: 1.3rem;
  }
`;
const ControlsContainer = styled_components_1.default.div `
  padding: 24px 24px 16px 24px;
  background: ${({ theme }) => theme.colors.NTDarkGrey[50]};
`;
const PanelContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.NTDarkGrey[900]};
  font-family: ${({ theme }) => theme.fonts.robotoMedium};
  background: ${({ theme }) => theme.colors.NTDarkGrey[50]};
`;
const LoadingContainer = styled_components_1.default.div `
    font-family: ${({ theme }) => theme.fonts.robotoMedium};
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.NTDarkGrey[500]};
`;
